const documentFormatter = (id: string | number): string => {
    const actualId = String(id);
    const cleanID = actualId.replace(/\D/g, '');

    if (cleanID.length === 11) {
        return cleanID.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
    } else if (cleanID.length === 14) {
        return cleanID.replace(
            /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
            '$1.$2.$3/$4-$5'
        );
    } else {
        return actualId;
    }
};

export { documentFormatter };
